import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { fetchLocationCoords, setSearchParams, fetchSearchResults } from '../store/slices/searchSlice';

const Villes = ({ villes, status }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Handle city click to fetch coords and redirect to ResultatRecherche
  const handleCityClick = async (ville, e) => {
    e.preventDefault(); // Prevent default browser behavior
    e.stopPropagation(); // Stop event bubbling

    try {
      let searchData;

      // Special case for "En ligne"
      if (ville.toLowerCase() === 'en ligne') {
        searchData = {
          location: null,
          query: '',
          how: ['enligne'],
          when: 'all_time',
          lat: null,
          lng: null,
          sortBy: 'relevance',
        };
      } else {
        // Fetch coordinates for physical locations
        const coords = await dispatch(fetchLocationCoords(ville)).unwrap();
        searchData = {
          location: ville,
          query: '',
          how: [],
          when: 'all_time',
          lat: coords.lat,
          lng: coords.lng,
          sortBy: 'relevance',
        };
      }

      // Set search params in Redux store
      dispatch(setSearchParams(searchData));

      // Dispatch fetchSearchResults to trigger the search
      dispatch(fetchSearchResults(searchData));

      // Navigate to ResultatRecherche with searchData in state and scroll to top
      navigate('/resultats', { state: { searchData } });
      window.scrollTo(0, 0); // Force scroll to top after navigation
    } catch (error) {
      // Fallback navigation without coords
    }
  };

  if (status === 'loading') {
    return (
      <div className="space-bloc gray-background bloc-villes">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3>
                <Skeleton width={300} height={30} />
              </h3>
            </div>
          </div>
          <div className="row mt-40">
            {[...Array(4)].map((_, index) => (
              <div className="col-md-3" key={index}>
                <h4>
                  <Skeleton width={150} height={25} />
                </h4>
                <p>
                  <Skeleton width="100%" height={15} count={2} />
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  if (status !== 'loading' && villes) {
    return (
      <div className="space-bloc gray-background bloc-villes">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <h3 className="grey500">Découvrez nos professionnels par lieux</h3>
            </div>
          </div>
          <div className="row mt-40">
            {villes?.map((element, index) => (
              <div
                className="col-md-3 hover-ville mt-16"
                key={index}
                onClick={(e) => handleCityClick(element?.ville.replace(', France', ''), e)} // Pass event
                style={{ cursor: 'pointer' }}
                role="button" // Improve accessibility
                tabIndex={0} // Make it focusable for accessibility
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault(); // Prevent scroll on Enter/Space
                    handleCityClick(element?.ville.replace(', France', ''), e);
                  }
                }}
              >
                <h6 className="grey500">{element?.ville.replace(', France', '')}</h6>
                <p className="body grey66">{element?.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default Villes;